import React from 'react';

export default ({ children, dispatch, ...props }) => (
  React.Children.map(
    children,
    child => React.cloneElement(child, props),
  )
);
